import axiosInstance from './axiosInstance'

export interface LeadNote {
  id:        string
  leadId:    string
  content:   string
  createdBy: { id: string; name: string; email: string; avatarUrl: string | null } | null
  createdAt: string
  updatedAt: string
}

export const leadNotesApi = {
  getAll:  (leadId: string) =>
    axiosInstance.get<{ data: LeadNote[] }>(`/leads/${leadId}/notes`).then(r => r.data.data),

  create:  (leadId: string, content: string) =>
    axiosInstance.post<{ data: LeadNote[] }>(`/leads/${leadId}/notes`, { content }).then(r => r.data.data),

  update:  (leadId: string, noteId: string, content: string) =>
    axiosInstance.put<{ data: LeadNote[] }>(`/leads/${leadId}/notes/${noteId}`, { content }).then(r => r.data.data),

  delete:  (leadId: string, noteId: string) =>
    axiosInstance.delete(`/leads/${leadId}/notes/${noteId}`),
}
